{
    "charts": {
        "terminals": {
            "status": {
                "title": "Terminals",
                "tooltip": "Distribution of POS terminals (outside terminated subscriptions)",
                "description": "By status",
                "count": "Count :"
            },
            "networks": {
                "title": "Networks",
                "tooltip": "Distribution by communication mode (outside terminated subscriptions)",
                "description": "By network",
                "count": "Count :",
                "network_interface_type": {
                    "UNKNOWN": "Unknown",
                    "GPRS": "Gprs",
                    "IP_WIFI": "IP / Wifi",
                    "GPRS_IP_WIFI": "Gprs / IP / Wifi"
                }
            },
            "manufacturers": {
                "title": "Manufacturer",
                "tooltip": "Distribution by manufacturer (outside terminated subscriptions)",
                "description": "By manufacturer",
                "count": "Count :"
            }
        },
        "sim_offers": {
            "title": "SIM offers",
            "tooltip": "Distribution by provider",
            "description": "By provider",
            "count": "Count :"
        },
        "contracts": {
            "applications": {
                "title": "Contracts by application",
                "tooltip": "Distribution by application, active contracts (TLC < 30 days)",
                "description": "By application",
                "count": "Count :"
            },
            "cb_versions": {
                "title": "Application version",
                "tooltip": "Distribution by CB version, active contracts (TLC < 30 days)",
                "description": "By CB version",
                "count": "Count :"
            }
        }
    },
    "global_stats": {
        "pos_terminals": {
            "title": "POS terminals",
            "tooltip": "Outside terminated subscriptions"
        },
        "remote_collection_24h_count": {
            "title": "Remote collections",
            "tooltip": "Number of remote collections in the last 24 hours"
        },
        "subscriptions": {
            "title": "Activation",
            "tooltip": "Active subscriptions over the last 24 hours"
        },
        "sim_cards": {
            "active": {
                "title": "Active SIM cards",
                "tooltip": "Number of SIM in active status"
            },
            "stock": {
                "title": "SIM in stock",
                "tooltip": "Number of SIM in inactive status",
                "WIRELESS_LOGIC": "{{number}} SIM service",
                "BOUYGUES_TELECOM": "{{number}} BT",
                "DEUTSCHE_TELEKOM": "{{number}} DT",
                "SIERRA_WIRELESS": "{{number}} Sierra Wireless"
            }
        }
    },
    "redirection": {
        "pos_terminals": "View POS terminals",
        "sim_cards": "View SIM cards",
        "contracts": "View contracts"
    }
}